import { Injectable } from "@angular/core";
import { AbstractService } from "../commons/abstract.service";
import { HttpClient } from "@angular/common/http";
import { FunnelCategory } from "../models/funnel.model";

@Injectable({ providedIn: 'root' })
export class FunnelCategoryService extends AbstractService<FunnelCategory> {
  constructor(private http: HttpClient ) {
    super(http);
  }

  getURLBase(): string {
    return '/funnel-category';
  }

  preCreate(obj: FunnelCategory): void {
    delete obj._id;
  }

  preUpdate(obj: FunnelCategory): void {
  }
}
